import React, { useRef, useState } from 'react'
import { getReservationLink } from "./getReservation"

import ButtonToggle from 'components/elements/buttons/toggle'

export const LogisticDropdown = ({
    show,
    title,
    data,
    onToggle,
    ...props
}) => {

    const [showReservation, setShowReservation] = useState(true)
    const [showBooking, setShowBooking] = useState(true)
    const [showTicket, setShowTicket] = useState(true)

    const handleToggleReservation = () => setShowReservation(isShow => !isShow)
    const handleToggleBooking = () => setShowBooking(isShow => !isShow)
    const handleToggleTicket = () => setShowTicket(isShow => !isShow)


    const logisticDropdownItems = [[], [], []] // [reservations, tickets, bookings]
    // filters
    const filter = r => {
        const isEventbrite = r?.name?.includes("Eventbrite")
        const isEtixResy = r?.name?.includes("Etix")
        const isTicketmaster = r?.name?.includes("Ticketmaster")
        const isBooking = r?.name?.includes("Booking")

        if (isBooking) {
            logisticDropdownItems[2].push({ ...r, name: "Booking.com" })
        } else if (isEventbrite || isEtixResy || isTicketmaster) {
            const name = r?.name === "Etix" ? "eTix" : r.name
            logisticDropdownItems[1].push({ ...r, name })
        } else {
            logisticDropdownItems[0].push(r)
        }
    }


    const reservationLinks = getReservationLink(data)
    //console.log('DEBUG RESERVATIONS ', reservationLinks, data);
    //reservationLinks?.forEach(filter)
    //console.log('DEBUG links data ', data);


    const ToggleButton = ({ title, show, onToggle }) => {
        return (
            <div className="header">
                <h4 className="title">{title}</h4>
                <ButtonToggle open={show} onToggle={onToggle} />
            </div>
        )
    }

    const ToggleSection = ({
        title,
        type = 'reserve', // book, ticket, reserve, etc
        ...props
    }) => {
        const linksFiltered = reservationLinks.filter(link => {
            const is_match = link?.type?.toLowerCase().includes(type) || link?.action?.toLowerCase().includes(type)
            return is_match
        })

        const iconStyle = {
            maxWidth: "20px",
        }

        const Icon = ({ icon }) => {
            return (
                <span style={iconStyle}>
                    {icon}
                </span>
            )
        }

        // Hide section if no links
        if (linksFiltered.length === 0) return null

        return (
            <div className="logistic__reservation">
                <ToggleButton title={title} show={show} onToggle={onToggle} />

                {show && (
                    <ul className="reservation-list">
                        {linksFiltered?.map((item, key) => (
                            <li className="reservation-item" key={key}>
                                <div className="title">
                                    <Icon icon={item.icon} />
                                    <span>{item.name}</span>
                                </div>
                                <a
                                    className="vibe-pill vibe-pill-25"
                                    href={item.url}
                                    style={{ textDecoration: "none" }}
                                >
                                    {item.action}
                                </a>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        )
    }

    return (
        <>
            <ToggleSection type='reservation' title='Reservations' />
            <ToggleSection type='book' title='Booking' />
            <ToggleSection type='ticket' title='Tickets' />
        </>

    )
}

export default LogisticDropdown